var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var typography = {
    fontSize: '14px',
    lineHeight: '1.6em',
    default: {
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
    },
    mono: {
        fontFamily: "'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace",
    },
};
var colors = {
    background: '#f8f8f8',
    text: '#555',
    border: '#ddd',
    accent: '#2b5fc5',
    overAccent: '#e6e9f5',
    muted: '#aaa',
    success: '#27e227',
    overSuccess: '#105b10',
    warning: '#ffb400',
    overWarning: '#7b3204',
    danger: '#e21702',
    overDanger: '#fff',
};
var theme = {
    typography: typography,
    colors: colors,
    tree: {
        container: {
            background: 'transparent',
        },
        item: {
            color: colors.text,
            hover: {
                background: '#fff',
                color: '#333',
            },
            current: {
                background: '#fff',
                color: '#000',
            },
        },
    },
    builder: {
        spacing: '12px',
        background: '#f8f8f8',
        header: {
            background: '#7286fc',
            title: {
                color: '#fff'
            },
            subtitle: {
                color: 'rgba(255, 255, 255, .65)'
            }
        },
        link: {
            color: '#7286fc'
        },
        label: {
            background: colors.accent,
            color: '#eee',
            css: styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n                box-shadow: 0 1px 3px rgba(0, 0, 0, .25);\n            "], ["\n                box-shadow: 0 1px 3px rgba(0, 0, 0, .25);\n            "]))),
        },
        block: {
            background: '#fff',
            css: styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                box-shadow: 0 1px 3px rgba(0, 0, 0, .1);\n            "], ["\n                box-shadow: 0 1px 3px rgba(0, 0, 0, .1);\n            "]))),
            title: {}
        },
    },
    badge: {
        background: '#eee',
        color: '#000',
    },
    header: {
        height: '44px',
        background: '#2b5fc5',
        color: '#fff',
        iconColor: '#fff',
        brandColor: '#fff',
    },
    pane: {
        spacing: '10px',
        css: styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            transition: box-shadow 300ms;\n            box-shadow: 0 0 0 1px rgba(4, 169, 244, 0), 0 0 0 1px rgba(0, 0, 0, .06);\n        "], ["\n            transition: box-shadow 300ms;\n            box-shadow: 0 0 0 1px rgba(4, 169, 244, 0), 0 0 0 1px rgba(0, 0, 0, .06);\n        "]))),
        current: {
            css: styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                box-shadow: 0 0 0 5px rgba(4, 169, 244, .08), 0 0 0 1px rgba(4, 169, 244, .25);\n            "], ["\n                box-shadow: 0 0 0 5px rgba(4, 169, 244, .08), 0 0 0 1px rgba(4, 169, 244, .25);\n            "]))),
        },
        header: {
            height: '34px',
            background: '#f5f5f5',
            button: {
                background: '#f5f5f5',
                current: {
                    background: '#fff',
                },
            },
        },
        body: {
            background: '#fff'
        }
    },
    editor: {
        theme: 'github',
    },
    form: {
        input: {
            background: '#f5f5f5',
            border: '1px solid #eee',
            color: colors.text,
            css: styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n                border-radius: 2px;\n            "], ["\n                border-radius: 2px;\n            "]))),
            placeholder: {
                color: '#aaa',
            },
            hover: {
                border: '1px solid #2196f3',
            },
            focus: {
                background: '#fff',
                border: '1px solid #2196f3',
                css: styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n                    box-shadow: 0 0 0 3px rgba(4, 169, 244, .2);\n                "], ["\n                    box-shadow: 0 0 0 3px rgba(4, 169, 244, .2);\n                "])))
            },
            disabled: {}
        },
        select: {
            background: 'white',
            arrowsColor: '#2b5fc5',
            addonBackground: 'rgba(4, 169, 244, .08)',
            borderColor: '#ddd',
            color: '#222',
            css: styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n                box-shadow: 0 1px 1px rgba(0, 0, 0, .06);\n                \n                &:hover {\n                    border-color: #2196f3;   \n                    box-shadow: 0 0 0 rgba(4, 169, 244, 0); \n                }\n            "], ["\n                box-shadow: 0 1px 1px rgba(0, 0, 0, .06);\n                \n                &:hover {\n                    border-color: #2196f3;   \n                    box-shadow: 0 0 0 rgba(4, 169, 244, 0); \n                }\n            "]))),
            focus: {
                css: styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n                    border-color: #2196f3;\n                    box-shadow: 0 0 0 3px rgba(4, 169, 244, .2);\n                "], ["\n                    border-color: #2196f3;\n                    box-shadow: 0 0 0 3px rgba(4, 169, 244, .2);\n                "])))
            },
        },
    },
    notifications: {
        item: {
            background: '#444',
            color: '#eee',
            css: styled_components_1.css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n                box-shadow: 0 2px 3px rgba(0, 0, 0, .1);\n            "], ["\n                box-shadow: 0 2px 3px rgba(0, 0, 0, .1);\n            "]))),
        },
    },
};
exports.default = theme;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
